import { render, staticRenderFns } from "./ContactsUnsubscribed.vue?vue&type=template&id=60335cb2"
import script from "./ContactsUnsubscribed.vue?vue&type=script&lang=js"
export * from "./ContactsUnsubscribed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports